// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Card$Showside from "./Card.bs.js";
import * as NavSDK$Showside from "../utils/NavSDK.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Favorites$Showside from "./Favorites.bs.js";
import * as MakerPage$Showside from "./MakerPage.bs.js";
import * as UseAnchors$Showside from "../hook/UseAnchors.bs.js";
import * as SectionTabs$Showside from "./SectionTabs.bs.js";
import * as WrapInIframe$Showside from "../utils/WrapInIframe.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as SectionHeader$Showside from "./SectionHeader.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as BackToTopButton$Showside from "./BackToTopButton.bs.js";
import * as CategoryContent$Showside from "./CategoryContent.bs.js";
import * as EditorLayerItem$Showside from "./EditorLayerItem.bs.js";
import * as ProductsContent$Showside from "./ProductsContent.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
import * as UserSavedProductsContent$Showside from "./UserSavedProductsContent.bs.js";
import * as UserSavedProductsProvider$Showside from "../context/UserSavedProductsProvider.bs.js";
function makeContentId(id) {
  return "sn-section-content-" + id;
}
function makeContainerId(id) {
  return "sn-section-container-" + id;
}
function SectionContent$SectionPlaceholder(Props) {
  var anchorHookResult = Props.anchorHookResult;
  var category = Props.category;
  var match = ViewportContext$Showside.use(undefined);
  var windowWidth = match.windowSize.width;
  ConfigurationProvider$Showside.use(undefined);
  var theme = BaseWithTheme$Showside.useLocalTheme(undefined);
  var containerWidth = Belt_Option.mapWithDefault(Category$Showside.Layout.getMaxWidth(category.userSelectedLayout), windowWidth, function (maxWidth) {
    return Math.min(windowWidth, maxWidth);
  });
  var match$1 = Card$Showside.Size.estimateSectionSize(containerWidth, /* Slider */0, Category$Showside.calculateGridColumns(category.card), Category$Showside.CategoryCard.getCardSize(undefined, category.card), Category$Showside.CategoryCard.getCardShape(undefined, undefined, category.card), Category$Showside.getChildren(category).length, theme);
  var height = match$1[1] + (category.showTitle ? 80 : 0) | 0;
  UseAnchors$Showside.useDelayedRegister(anchorHookResult, category);
  return React.createElement("div", {
    "aria-hidden": true,
    "aria-label": category.title,
    className: CSS$Showside.prefix("pt-row-custom-half pb-row-custom-half"),
    id: "sn-section-container-" + category.id,
    role: "region",
    style: {
      height: CSS$Showside.intToPx(height)
    }
  });
}
SectionContent$SectionPlaceholder.displayName = "SectionContent.SectionPlaceholder";
var SectionPlaceholder = {
  make: SectionContent$SectionPlaceholder
};
function SectionContent(Props) {
  var children = Props.children;
  var index = Props.index;
  var preferredContentType = Props.preferredContentType;
  var shouldShowHeaderOpt = Props.shouldShowHeader;
  var shouldShowBackToTopButtonOpt = Props.shouldShowBackToTopButton;
  var isZoomEnabledOpt = Props.isZoomEnabled;
  var applyVisibleInParentOpt = Props.applyVisibleInParent;
  var applyVisibleInHeaderOpt = Props.applyVisibleInHeader;
  var category = Props.category;
  var refreshUserSavedProductsOpt = Props.refreshUserSavedProducts;
  var parentCategory = Props.parentCategory;
  var layout = Props.layout;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var forcedShape = Props.forcedShape;
  var forcedSize = Props.forcedSize;
  var forcedOpenLink = Props.forcedOpenLink;
  var enableSmartCard = Props.enableSmartCard;
  var enableFirstCard = Props.enableFirstCard;
  var enableLastCard = Props.enableLastCard;
  var enableInlineMedia = Props.enableInlineMedia;
  var isPaddingEnabledOpt = Props.isPaddingEnabled;
  var isThemeEnabledOpt = Props.isThemeEnabled;
  var shouldCenterSlides = Props.shouldCenterSlides;
  var priority = Props.priority;
  var anchorHookResult = Props.anchorHookResult;
  var overrideTabSettings = Props.overrideTabSettings;
  var layoutControllerHookOpt = Props.layoutControllerHook;
  var className = Props.className;
  var customTitle = Props.customTitle;
  var onTitleClick = Props.onTitleClick;
  var onLinkClick = Props.onLinkClick;
  var shouldShowHeader = shouldShowHeaderOpt !== undefined ? shouldShowHeaderOpt : true;
  var shouldShowBackToTopButton = shouldShowBackToTopButtonOpt !== undefined ? shouldShowBackToTopButtonOpt : false;
  var isZoomEnabled = isZoomEnabledOpt !== undefined ? isZoomEnabledOpt : true;
  var applyVisibleInParent = applyVisibleInParentOpt !== undefined ? applyVisibleInParentOpt : true;
  var applyVisibleInHeader = applyVisibleInHeaderOpt !== undefined ? applyVisibleInHeaderOpt : false;
  var refreshUserSavedProducts = refreshUserSavedProductsOpt !== undefined ? refreshUserSavedProductsOpt : true;
  var isPaddingEnabled = isPaddingEnabledOpt !== undefined ? isPaddingEnabledOpt : true;
  var isThemeEnabled = isThemeEnabledOpt !== undefined ? isThemeEnabledOpt : true;
  var layoutControllerHook = layoutControllerHookOpt !== undefined ? layoutControllerHookOpt : ListPageLayoutController$Showside.emptyHook;
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var viewportContextValue = ViewportContext$Showside.use(undefined);
  var routerProvider = RouterProvider$Showside.useRouter(undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onTitleClick$1 = Belt_Option.getWithDefault(onTitleClick, match$1.onSectionTitleClick);
  var onLinkClick$1 = Belt_Option.getWithDefault(onLinkClick, match$1.onSectionLinkClick);
  var configLastModifiedAt = config.lastModifiedAt;
  var settings = config.settings;
  var match$2 = CartContextProvider$Showside.useCart(undefined);
  var cart = match$2.cart;
  var checkoutLink = settings.cart ? match$2.storeCheckoutLink : settings.checkoutLink;
  var layoutController = ListPageLayoutController$Showside.Context.use(undefined);
  var ref = React.useRef(null);
  Curry._1(layoutControllerHook, ref);
  var isMobile = viewportContextValue.isMobile;
  var activeCategoryId = RouterProvider$Showside.getListPageCategoryId(routerProvider.route);
  var favorites = Favorites$Showside.useFavorites(undefined);
  var match$3 = UserSavedProductsProvider$Showside.use(undefined);
  var history = match$3.history;
  var match$4 = category.tabbedSubCategories;
  var tabbedSubCategories = match$4 !== undefined ? overrideTabSettings !== undefined ? overrideTabSettings : category.tabbedSubCategories : undefined;
  var enableTabs = Belt_Option.isSome(tabbedSubCategories) && !Category$Showside.isQuickView(category);
  var category$1 = React.useMemo(function () {
    var match = category.socialNetworkSource;
    if (match !== undefined && match.TAG === /* Instagram */0) {
      return Category$Showside.setChildren(category, Belt_Option.mapWithDefault(Category$Showside.getInstagramFeed(category), Category$Showside.getChildren(category), Category$Showside.getChildren));
    } else {
      return category;
    }
  }, [category]);
  var match$5 = SectionTabs$Showside.useTabs(enableTabs, category$1, configLastModifiedAt);
  var allTab = match$5.allTab;
  var setActiveTab = match$5.setActiveTab;
  var activeTab = match$5.activeTab;
  var getSubCategories = function (prependAllTabOpt, applyVisibleInParent$1, applyVisibleInHeader$1, category) {
    var prependAllTab = prependAllTabOpt !== undefined ? prependAllTabOpt : true;
    var applyVisibleInParent$2 = Belt_Option.getWithDefault(applyVisibleInParent$1, applyVisibleInParent);
    var applyVisibleInHeader$2 = Belt_Option.getWithDefault(applyVisibleInHeader$1, applyVisibleInHeader);
    return Belt_Array.concat(Belt_Array.keepMap(prependAllTab ? [allTab] : [], function (a) {
      return a;
    }), Belt_Array.keep(Belt_Array.keep(Category$Showside.getChildren(category), function (category) {
      if (applyVisibleInParent$2) {
        return category.visibleInParent;
      } else {
        return true;
      }
    }), function (category) {
      if (applyVisibleInHeader$2) {
        return category.visibleInHeaderSlider;
      } else {
        return true;
      }
    }));
  };
  var subCategories = React.useMemo(function () {
    return getSubCategories(false, undefined, undefined, category$1);
  }, [configLastModifiedAt, category$1.id, isMobile]);
  var tabContent = React.useMemo(function () {
    return Js_dict.fromArray(Belt_Array.map(getSubCategories(undefined, false, false, category$1), function (subCategory) {
      var key = subCategory.id;
      var match = Category$Showside.ExternalConnection.getConnection(subCategory);
      var value;
      var exit = 0;
      if (match !== undefined && typeof match === "number") {
        switch (match) {
          case /* History */0:
            value = {
              TAG: /* History */2,
              category: subCategory,
              count: history.value.length
            };
            break;
          case /* Favorites */1:
            value = {
              TAG: /* Favorites */3,
              category: subCategory,
              count: favorites.count
            };
            break;
          case /* StoreCart */2:
            value = {
              TAG: /* StoreCart */4,
              category: subCategory,
              count: cart.itemCount
            };
            break;
        }
      } else {
        exit = 1;
      }
      if (exit === 1) {
        value = Category$Showside.hasSubCategories(subCategory) ? {
          TAG: /* Category */0,
          category: subCategory,
          subCategories: getSubCategories(false, undefined, undefined, subCategory)
        } : {
          TAG: /* Products */1,
          category: subCategory
        };
      }
      return [key, value];
    }));
  }, [configLastModifiedAt, category$1.id, isMobile]);
  UseAnchors$Showside.useDelayedRegister(anchorHookResult, category$1);
  var onTabChange = Curry.__1(setActiveTab);
  var connection = Category$Showside.ExternalConnection.getConnection(category$1);
  var link = Category$Showside.Link.getCardFallbackLink(category$1);
  var content = Belt_Option.flatMap(activeTab, function (activeTab) {
    return Js_dict.get(tabContent, activeTab.id);
  });
  var contentType;
  if (content !== undefined) {
    contentType = content;
  } else {
    switch (preferredContentType) {
      case /* Products */0:
        contentType = {
          TAG: /* Products */1,
          category: category$1
        };
        break;
      case /* Category */1:
        contentType = {
          TAG: /* Category */0,
          category: category$1,
          subCategories: subCategories
        };
        break;
      case /* Favorites */2:
        contentType = {
          TAG: /* Favorites */3,
          category: category$1,
          count: favorites.count
        };
        break;
      case /* History */3:
        contentType = {
          TAG: /* History */2,
          category: category$1,
          count: history.value.length
        };
        break;
      case /* StoreCart */4:
        contentType = {
          TAG: /* StoreCart */4,
          category: category$1,
          count: cart.itemCount
        };
        break;
    }
  }
  var contentType$1;
  if (contentType.TAG === /* Products */1) {
    var match$6 = contentType.category.socialNetworkSource;
    contentType$1 = match$6 !== undefined && match$6.TAG !== /* Instagram */0 ? {
      TAG: /* Category */0,
      category: Belt_Option.getWithDefault(Category$Showside.getTiktokFeed(category$1), category$1),
      subCategories: Belt_Option.mapWithDefault(Category$Showside.getTiktokFeed(category$1), subCategories, Category$Showside.getChildren)
    } : contentType;
  } else {
    contentType$1 = contentType;
  }
  var onLinkClick$2 = connection !== undefined && link !== undefined ? onLinkClick$1 : undefined;
  var match$7 = settings.checkoutLink;
  var linkLabel;
  linkLabel = contentType$1.TAG === /* StoreCart */4 && match$7 !== undefined ? "Checkout Now" : settings.openLinkLabel;
  var linkHref;
  linkHref = contentType$1.TAG === /* StoreCart */4 ? checkoutLink : undefined;
  var tmp = {
    category: category$1,
    linkLabel: linkLabel,
    layout: layout,
    onTitleClick: onTitleClick$1
  };
  if (linkHref !== undefined) {
    tmp.linkHref = linkHref;
  }
  if (customTitle !== undefined) {
    tmp.customTitle = Caml_option.valFromOption(customTitle);
  }
  if (onLinkClick$2 !== undefined) {
    tmp.onLinkClick = Caml_option.valFromOption(onLinkClick$2);
  }
  var sectionHeader = React.createElement(ConditionalRender$Showside.When.make, {
    condition: shouldShowHeader,
    children: React.createElement(SectionHeader$Showside.make, tmp)
  });
  var isMkrBioContent = Belt_Option.mapWithDefault(parentCategory, false, function (parent) {
    return Belt_Option.isSome(parent.socialNetworkSource);
  });
  var enableScrollbar = !isMkrBioContent;
  var verticalPadding = isMkrBioContent && index === 0;
  var forcedRounded = !isMkrBioContent;
  var match$8 = category$1.categoryType;
  var content$1;
  if (typeof match$8 === "number") {
    content$1 = Caml_option.some(React.createElement(MakerPage$Showside.make, {
      config: config,
      elementId: category$1.id
    }));
  } else {
    switch (match$8.TAG | 0) {
      case /* CustomComponentSection */5:
        var component = match$8._0.component;
        content$1 = Caml_option.some(React.createElement(NavSDK$Showside.CustomSectionRenderer.make, {
          componentId: component.id,
          renderFallback: function (param) {
            return null;
          },
          props: component.props
        }));
        break;
      case /* EmbedCodeSection */6:
        var embed = match$8._0;
        var px = embed.size[0];
        content$1 = Caml_option.some(React.createElement(WrapInIframe$Showside.make, {
          style: {
            margin: "0 auto",
            width: px ? CSS$Showside.intToPx(px._0) : "100%"
          },
          children: embed.code
        }));
        break;
      default:
        switch (contentType$1.TAG | 0) {
          case /* Category */0:
            var subCategories$1 = contentType$1.subCategories;
            if (subCategories$1.length !== 0) {
              var tmp$1 = {
                category: contentType$1.category,
                scrollableContainerRef: scrollableContainerRef,
                layout: layout,
                enableScrollbar: enableScrollbar,
                index: index,
                isPaddingEnabled: isPaddingEnabled,
                verticalPadding: verticalPadding,
                subCategories: subCategories$1,
                forcedRounded: forcedRounded,
                onOverlayProductClick: match$1.onOverlayProductClick,
                onCategoryClick: match$1.onCategoryClick,
                onQuickViewClick: match$1.onQuickViewClick,
                onProductClick: match$1.onProductClick
              };
              if (enableSmartCard !== undefined) {
                tmp$1.enableSmartCard = Caml_option.valFromOption(enableSmartCard);
              }
              if (enableFirstCard !== undefined) {
                tmp$1.enableFirstCard = Caml_option.valFromOption(enableFirstCard);
              }
              if (enableLastCard !== undefined) {
                tmp$1.enableLastCard = Caml_option.valFromOption(enableLastCard);
              }
              if (shouldCenterSlides !== undefined) {
                tmp$1.shouldCenterSlides = Caml_option.valFromOption(shouldCenterSlides);
              }
              if (priority !== undefined) {
                tmp$1.priority = Caml_option.valFromOption(priority);
              }
              if (forcedSize !== undefined) {
                tmp$1.forcedSize = Caml_option.valFromOption(forcedSize);
              }
              if (forcedShape !== undefined) {
                tmp$1.forcedShape = Caml_option.valFromOption(forcedShape);
              }
              if (forcedOpenLink !== undefined) {
                tmp$1.forcedOpenLink = Caml_option.valFromOption(forcedOpenLink);
              }
              content$1 = Caml_option.some(React.createElement(CategoryContent$Showside.make, tmp$1));
            } else {
              content$1 = undefined;
            }
            break;
          case /* Products */1:
            var category$2 = contentType$1.category;
            if (Category$Showside.hasProducts(category$2)) {
              var tmp$2 = {
                category: category$2,
                scrollableContainerRef: scrollableContainerRef,
                layout: layout,
                isPaddingEnabled: isPaddingEnabled,
                isZoomEnabled: isZoomEnabled
              };
              if (shouldCenterSlides !== undefined) {
                tmp$2.shouldCenterSlides = Caml_option.valFromOption(shouldCenterSlides);
              }
              if (enableSmartCard !== undefined) {
                tmp$2.enableSmartCard = Caml_option.valFromOption(enableSmartCard);
              }
              if (enableFirstCard !== undefined) {
                tmp$2.enableFirstCard = Caml_option.valFromOption(enableFirstCard);
              }
              if (enableLastCard !== undefined) {
                tmp$2.enableLastCard = Caml_option.valFromOption(enableLastCard);
              }
              if (enableInlineMedia !== undefined) {
                tmp$2.enableInlineMedia = Caml_option.valFromOption(enableInlineMedia);
              }
              if (priority !== undefined) {
                tmp$2.priority = Caml_option.valFromOption(priority);
              }
              if (forcedSize !== undefined) {
                tmp$2.forcedSize = Caml_option.valFromOption(forcedSize);
              }
              if (forcedShape !== undefined) {
                tmp$2.forcedShape = Caml_option.valFromOption(forcedShape);
              }
              if (forcedOpenLink !== undefined) {
                tmp$2.forcedOpenLink = Caml_option.valFromOption(forcedOpenLink);
              }
              content$1 = Caml_option.some(React.createElement(ProductsContent$Showside.make, tmp$2));
            } else {
              content$1 = undefined;
            }
            break;
          case /* History */2:
            var category$3 = contentType$1.category;
            if (contentType$1.count > 0 || Caml_obj.equal(category$3.id, activeCategoryId)) {
              var tmp$3 = {
                layout: layout,
                category: category$3,
                isPaddingEnabled: isPaddingEnabled,
                fixedOrder: !refreshUserSavedProducts,
                requestType: "history"
              };
              if (shouldCenterSlides !== undefined) {
                tmp$3.shouldCenterSlides = Caml_option.valFromOption(shouldCenterSlides);
              }
              content$1 = Caml_option.some(React.createElement(UserSavedProductsContent$Showside.make, tmp$3));
            } else {
              content$1 = undefined;
            }
            break;
          case /* Favorites */3:
            var category$4 = contentType$1.category;
            if (contentType$1.count > 0 || Caml_obj.equal(category$4.id, activeCategoryId)) {
              var tmp$4 = {
                layout: layout,
                category: category$4,
                isPaddingEnabled: isPaddingEnabled,
                fixedOrder: !refreshUserSavedProducts,
                requestType: "favorites"
              };
              if (shouldCenterSlides !== undefined) {
                tmp$4.shouldCenterSlides = Caml_option.valFromOption(shouldCenterSlides);
              }
              content$1 = Caml_option.some(React.createElement(UserSavedProductsContent$Showside.make, tmp$4));
            } else {
              content$1 = undefined;
            }
            break;
          case /* StoreCart */4:
            var category$5 = contentType$1.category;
            if (contentType$1.count > 0 || Caml_obj.equal(category$5.id, activeCategoryId)) {
              var tmp$5 = {
                layout: layout,
                category: category$5,
                isPaddingEnabled: isPaddingEnabled,
                fixedOrder: !refreshUserSavedProducts,
                requestType: "cart"
              };
              if (shouldCenterSlides !== undefined) {
                tmp$5.shouldCenterSlides = Caml_option.valFromOption(shouldCenterSlides);
              }
              content$1 = Caml_option.some(React.createElement(UserSavedProductsContent$Showside.make, tmp$5));
            } else {
              content$1 = undefined;
            }
            break;
        }
    }
  }
  var contentCategoryId;
  switch (contentType$1.TAG | 0) {
    case /* Category */0:
    case /* Products */1:
    case /* History */2:
    case /* Favorites */3:
    case /* StoreCart */4:
      contentCategoryId = contentType$1.category.id;
      break;
  }
  var description;
  var exit = 0;
  var description$1;
  var showDescription;
  switch (contentType$1.TAG | 0) {
    case /* Category */0:
      var match$9 = contentType$1.category;
      description$1 = match$9.description;
      showDescription = match$9.showDescription;
      exit = 1;
      break;
    case /* Products */1:
      var match$10 = contentType$1.category;
      description$1 = match$10.description;
      showDescription = match$10.showDescription;
      exit = 1;
      break;
    case /* History */2:
      var match$11 = contentType$1.category;
      description$1 = match$11.description;
      showDescription = match$11.showDescription;
      exit = 1;
      break;
    case /* Favorites */3:
      var match$12 = contentType$1.category;
      description$1 = match$12.description;
      showDescription = match$12.showDescription;
      exit = 1;
      break;
    case /* StoreCart */4:
      var match$13 = contentType$1.category;
      description$1 = match$13.description;
      showDescription = match$13.showDescription;
      exit = 1;
      break;
  }
  if (exit === 1) {
    description = activeTab !== undefined && showDescription ? description$1 : undefined;
  }
  var backToTopButton = React.createElement(ConditionalRender$Showside.When.make, {
    condition: shouldShowBackToTopButton,
    children: React.createElement(BackToTopButton$Showside.make, {
      scrollableContainerRef: scrollableContainerRef,
      position: "sticky"
    })
  });
  var isSectionSticky = category$1.stickySection;
  var stickyContainerStyles = isSectionSticky ? {
    position: "sticky",
    top: CSS$Showside.intToPx(layoutController.state.showPrimaryNavbar ? (layoutController.state.primaryNavbarHeight + layoutController.state.toolbarHeight | 0) + layoutController.state.secondaryNavbarHeight | 0 : layoutController.state.toolbarHeight + layoutController.state.secondaryNavbarHeight | 0),
    zIndex: "1",
    transition: "top 0.3s cubic-bezier(.4,0,.2,1)"
  } : undefined;
  if (content$1 === undefined) {
    return null;
  }
  var tmp$6;
  tmp$6 = layout.TAG === /* SliderLayout */0 ? "section-content-slider" : "section-content-grid";
  var tmp$7 = {
    category: category$1,
    index: index,
    tabs: match$5.tabs,
    onTabChange: onTabChange,
    children: React.createElement(DataAttribute$Showside.make, {
      dataTestId: tmp$6,
      dataId: category$1.title,
      children: React.createElement("div", {
        id: "sn-section-content-" + contentCategoryId
      }, Caml_option.valFromOption(content$1))
    }),
    maxWidth: Category$Showside.Layout.getMaxWidth(category$1.userSelectedLayout),
    padding: Category$Showside.Layout.getPadding(category$1.userSelectedLayout)
  };
  if (activeTab !== undefined) {
    tmp$7.activeTab = Caml_option.valFromOption(activeTab);
  }
  if (tabbedSubCategories !== undefined) {
    tmp$7.settings = Caml_option.valFromOption(tabbedSubCategories);
  }
  if (description !== undefined) {
    tmp$7.description = description;
  }
  var children$1 = React.createElement(React.Fragment, undefined, sectionHeader, React.createElement(SectionTabs$Showside.make, tmp$7), backToTopButton, Belt_Option.getWithDefault(children, null));
  var tmp$8 = {
    kind: "section",
    id: "sn-section-container-" + category$1.id,
    nodeId: category$1.id,
    role: "region",
    ariaLabel: category$1.title,
    fwdRef: ReactDOMUtils$Showside.Ref.domRef(ref),
    category: category$1,
    children: isThemeEnabled ? React.createElement(BaseWithTheme$Showside.make, {
      initiator: "clp-section",
      reference: category$1.sectionTheme,
      className: Cn.make([CSS$Showside.prefix("group space-y-6"), CSS$Showside.prefix("hide-on-empty"), CSS$Showside.prefix("pt-section-padding-top pb-section-padding-bottom"), CSS$Showside.prefix("bg-main"), Belt_Option.getWithDefault(className, "")]),
      portal: false,
      children: children$1
    }) : React.createElement("div", {
      className: Cn.make([CSS$Showside.prefix("group space-y-6"), CSS$Showside.prefix("hide-on-empty"), CSS$Showside.prefix("pt-section-padding-top pb-section-padding-bottom"), CSS$Showside.prefix("bg-main"), Belt_Option.getWithDefault(className, "")])
    }, children$1)
  };
  if (stickyContainerStyles !== undefined) {
    tmp$8.style = Caml_option.valFromOption(stickyContainerStyles);
  }
  return React.createElement(EditorLayerItem$Showside.make, tmp$8);
}
SectionContent.displayName = "SectionContent";
var make = React.memo(SectionContent);
var $$default = make;
export { makeContentId, makeContainerId, SectionPlaceholder, make, $$default, $$default as default };
/* make Not a pure module */